module.exports = __webpack_public_path__ + "static/media/cyklopas-logo-etext-cinv-horizontal.0842cff7.svg";